import { createCmsDuck } from 'helpers/cms';

export const reducer = createCmsDuck({
  page: '@step1-main-bgimage-content-classifieds',
  path: ['sellWidget'],
});
